/* Native collection sorting: preserve filters, locale and preview parameters,
   and always start the new order on page one. No menu handlers or jQuery. */
(function () {
  'use strict';
  if (window.serlexCollectionSortBound) return;
  window.serlexCollectionSortBound = true;

  function sortCollection(form) {
    var select = form.querySelector('[data-serlex-sort-select]');
    if (!select || !select.value) return false;
    var destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', select.value);
    destination.searchParams.delete('page');
    window.location.assign(destination.toString());
    return true;
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-serlex-sort-select]') && event.target.form) {
      sortCollection(event.target.form);
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches('[data-serlex-sort-form]') && sortCollection(event.target)) {
      event.preventDefault();
    }
  });
}());
